(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-sec"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        const faqItem = this.closest('[data-faq-item]');
        const isActive = faqItem.classList.contains('active');

        document.querySelectorAll('[data-faq-item]').forEach(item => {
          if (item !== faqItem) {
            item.classList.remove('active');
            item.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
          }
        });

        if (isActive) {
          faqItem.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
        } else {
          faqItem.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
